export default function contactPage() {
	const contactPage = document.querySelector('.contact-page');
	const orderPage = document.querySelector('.order-page');

	if (contactPage) {

		const updateInputValue = id => {
			const inputField = document.querySelector(`input#${id}`);
			let month = document.querySelector('.date-in.date-in-month');
			let year = document.querySelector('.date-in.date-in-year');
			if (month && year) {
				inputField.value = `${month.value}/${year.value}`;
			}
		}
		document.querySelectorAll('.date-in').forEach(dateIn => {
			dateIn.addEventListener('keyup', event => {
				let field = event.target;
				let maxLength = parseInt(field.maxLength);
				if (field.value.length > maxLength) {
					field.value = field.value.substring(0, maxLength);
				}
			});
			dateIn.addEventListener('change', event => {
				let field = event.target;
				let value = parseInt(field.value);
				let maxValue = parseInt(field.max);
				let minValue = parseInt(field.min);
				if (value > maxValue) {
					field.value = maxValue;
				} else if (value < minValue) {
					field.value = minValue;
				}
				updateInputValue(field.dataset.fieldId);
			});
		});
	}
	if (orderPage) {
		sessionStorage.removeItem('paymentSelector');
	}
}


// WEBPACK FOOTER //
// ./source/scripts/pages/contact.js